module.exports = __webpack_public_path__ + "img/tcm-welcome.a067c435.png";